export const environment = {
  production: false,
  url: 'https://api.carvia-test.org/vendor-service/',
  shareUrl:'https://linkageit-careers.carvia-test.org/job/',
  otpDuration: 60
};
